import styled from 'styled-components';
export const StyledCurrencyWrapper = styled.div.withConfig({
  displayName: "StyledCurrencyWrapper",
  componentId: "sc-1rlhps9-0"
})(["white-space:nowrap;display:inline-block;"]);